import AutoFixHighIcon from "@mui/icons-material/AutoFixHigh";
import Button from "@mui/material/Button";
import Stack from "@mui/material/Stack";
import Tooltip from "@mui/material/Tooltip";
import { blue } from "@mui/material/colors";
import { type SxProps, useTheme } from "@mui/material/styles";
import useMediaQuery from "@mui/material/useMediaQuery";

import useCanManageScribeTemplates from "features/medical-scribe/hooks/use-can-manage-scribe-templates.hook";
import { getScribeModalPopoverZIndex } from "features/medical-scribe/medical-scribe-constants";

type ManageScribeTemplatesButtonProps = {
  disabled?: boolean;
  sx?: SxProps;
};

export default function ManageScribeTemplatesButton({
  disabled,
  sx
}: ManageScribeTemplatesButtonProps) {
  const canManageTemplates = useCanManageScribeTemplates();
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("mobile"));

  if (!canManageTemplates) {
    return null;
  }

  return (
    <Stack height="100%" justifyContent="center">
      {/* Also rendered inside the scribe modals, which sit above MUI's tooltip layer. */}
      <Tooltip
        title="Open Scribe Template settings"
        PopperProps={{
          style: { zIndex: getScribeModalPopoverZIndex(theme.zIndex.snackbar) }
        }}
      >
        <Button
          data-testid="manage-scribe-templates-button"
          variant="contained"
          size="small"
          disabled={disabled}
          startIcon={<AutoFixHighIcon />}
          onClick={() =>
            window.open("/settings/scribes", "_blank", "noopener,noreferrer")
          }
          sx={{
            fontSize: "14px",
            minWidth: isMobile ? undefined : "210px",
            "&&.MuiButton-contained:not(.Mui-disabled)": {
              // White on blue[500] is 3.1:1 at 14px; blue[700] is 4.6:1.
              background: blue[700],
              color: "white",
              "&:hover": {
                background: blue[800]
              }
            },
            ...sx
          }}
        >
          Manage Scribe Templates
        </Button>
      </Tooltip>
    </Stack>
  );
}
